import React from "react";
import { FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function FloatingStudentCaseCta() {
  const { t } = useTranslation();

  return (
    <Link
      to="/jharkhand-fir-details/"
      className="floating-student-case-cta"
      aria-label={t("footer.submitCaseShort")}
    >
      <FileText size={18} aria-hidden="true" />
      <span>{t("footer.submitCaseShort")}</span>
    </Link>
  );
}
